/*
 * Public API Surface of pepperi-lib/internal-button
 */
export * from './internal-button.module';
export * from './internal-button.component';
